module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Download-7030e191395b43aeb2506b355fa0bc2d.svg";